import React, { useState } from "react";
import { Link } from "react-router-dom";
import RoundRectButton from "../customized/RoundRectButton";
import { useImages } from "../hooks/useImages";

const GUIDS = {
  logo: '21904a9b-853e-4440-96e2-c149d39d0c52'
}

const Navbar: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  const handleNavClick = () => {
    window.scrollTo(0, 0);
    setIsMobileMenuOpen(false);
  };

  const logoImage = useImages(GUIDS.logo)?.image;

  // Define navigation links once
  const navLinks = [
    { to: "/", label: "Home" },
    { to: "commercial", label: "Commercial" },
    { to: "drop-off-locations", label: "Drop Off Locations" },
    { to: "what-is-composting", label: "What Is Composting?" },
    { to: "contact-us", label: "Contact Us" },
    { to: "faqs", label: "FAQs" }
  ];

  // Define auth buttons
  const authButtons = (isMobile: boolean) => (
    <>      
      <RoundRectButton
        label="Sign Up!"
        className={isMobile ? "w-full" : "px-6"}
        hoverColor="hover:bg-orange-500"
        onClick={() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
          window.location.hash = "signUp";
        }}

      />
      <RoundRectButton
        label="Billing Portal"
        bgColor="bg-green-600"
        hoverColor="hover:bg-green-500"
        //onClick={() => window.open("https://billing.stripe.com/p/login/test_eVqaEX1mO8xQ15Vcp2d3i00", "_blank")}// development
        onClick={() => window.open("https://billing.stripe.com/p/login/eVa4hGeFLfMm4Lu144", "_blank")}
        className={isMobile ? "w-full" : ""}
      />
    </>
  );

  return (
    <nav className="fixed start-0 top-0 z-20 w-full bg-white font-sans shadow">
      <div className="mx-auto flex max-w-screen-xl items-center justify-between px-4 py-3">
        {/* Left section - Logo */}
        <Link to="/" className="flex-shrink-0">
          <img
            src={logoImage}
            className="h-16 w-auto"
            alt="Logo"
          />
        </Link>

        {/* Mobile menu button */}
        <button
          onClick={toggleMobileMenu}
          className="md:hidden p-2 text-gray-600 hover:text-orange-600"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {isMobileMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center justify-between flex-1 ml-8">
          <div className="flex items-center space-x-6">
            {navLinks.map((link) => (
              <Link
                key={link.label}
                to={link.to}
                onClick={handleNavClick}
                className="text-lg text-black hover:text-orange-600 transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="flex items-center space-x-4">
            {authButtons(false)}
          </div>
        </div>

        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <div className="absolute top-full left-0 right-0 bg-white shadow-lg md:hidden">
            <div className="px-4 py-3 space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.label}
                  to={link.to}
                  onClick={handleNavClick}
                  className="block text-lg text-black hover:text-orange-600"
                >
                  {link.label}
                </Link>
              ))}
              <div className="space-y-4">
                {authButtons(true)}
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;